import Page from './index';

export default {
	settings: {
		layout: {
			config: {}
		}
	},
	// auth: authRoles.user,
	routes: [
		{
			path: '/roles',
			exact: true,
			component: Page.Layout
		},
	]
};
